export default function initializeOptionsSlider() {
    document.querySelectorAll('.block-opinions-slider').forEach(function (block) {
        new OpinionsSlider(block);
    });
}

class OpinionsSlider {
    constructor(block) {
        this.block = block;
        this.init();
    }

    init() {
        import('swiper/bundle').then(({ default: Swiper }) => {
            const swiper = new Swiper(this.block.querySelector('.block-opinions-slider__swiper-container'), {
                slidesPerView: 1,
                spaceBetween: 60,
                speed: 1500,
                loop: false,
                freeMode: false,
                centeredSlides: true,
                autoplay: {
                    delay: 10000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: this.block.querySelector('.block-opinions-slider__swiper-pagination'),
                    clickable: true,
                },
                on: {
                    slideChangeTransitionEnd: () => {
                        this.updateSlideStyles(swiper);
                    },
                },
            });

            this.updateSlideStyles(swiper);
        });
    }

    updateSlideStyles(swiper) {
        swiper.slides.forEach((slide, index) => {
            if (!slide.classList.contains('swiper-slide-active')) {
                slide.classList.add('blur-slide');
            }
        });
    }
}
